// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2dCu4","bigColWidth":"Table_bigColWidth__Gr88X","biggerColWidth":"Table_biggerColWidth__6q9Io","row":"Table_row__3umRv","col":"Table_col__3Jszh"};